<div [class.navigation-item--closed]="closed()" [class.navigation-item--active]="selected()">
  <a
    role="button"
    tabindex="0"
    (keydown.enter)="navigate(item())"
    (click)="navigate(item())"
    (navigate)="navigate($event)"
    [tessNavigationPopover]="item()"
    [isMenuClosed]="closed() && ended()"
    [closePopover]="closePopover()"
    class="cursor-pointer text-sm min-h-10 navigation-item__content menu">
    <div class="menu__left text-white">
      <lib-tess-icon [icon]="'menu:' + item().Icon" size="var(--font-size-xxl)" />
    </div>

    <div class="menu__right">
      <div class="flex items-center justify-between w-full pl-4 pr-2 py-0 text-white">
        {{ item().RouteDefinition.title }}
        @if (subItems()) {
          <div class="navigation-item__arrow transition-transform text-white opacity-70 flex">
            <lib-tess-icon icon="my-icons:arrow-right" size="var(--font-size-s)" color="var(--white)" />
          </div>
        }
      </div>
    </div>
  </a>

  @if (subItems()) {
    <div
      class="max-h-0 overflow-clip text-xs navigation-item__sub"
      [class.navigation-item__sub--open]="open() || subSelected() || selected()">
      @for (subItem of subItems(); track subItem.Id) {
        <a
          role="button"
          tabindex="0"
          (keydown.enter)="navigate(subItem)"
          (click)="navigate(subItem)"
          class="cursor-pointer text-sm min-h-10 navigation-item__content navigation-item--sub menu">
          <div
            class="menu__left navigation-item__left dark:fill-dark-200"
            [ngClass]="{
              'text-white stroke-gray-500 opacity-70': !subItem.selected,
              'text-blue-400 stroke-blue-400 opacity-100': subItem.selected,
            }">
            <lib-tess-icon size="var(--font-size-m)" icon="menu:circle" />
          </div>
          <div class="menu__right">
            <div
              class="flex items-center justify-between w-full pl-4 pr-2 py-0"
              [ngClass]="{
                'text-white opacity-70': !subItem.selected,
                'text-blue-400 opacity-100': subItem.selected,
              }">
              {{ subItem.RouteDefinition.title }}
            </div>
          </div>
        </a>
      }
    </div>
  }
</div>
